import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import calendarReducer from './slices/calendarSlice';
import dashboardReducer from './slices/dashboardSlice';
import dealsReducer from './slices/dealsSlice';
import integrationReducer from './slices/integrationSlice';
import leadsReducer from './slices/leadsSlice';
import contactReducer from './slices/contactSlice';
import rolesAndPermissionsReducer from './slices/rolesAndPermissionsSlice';

export const store = configureStore({
  reducer: {
    calendar: calendarReducer,
    dashboard: dashboardReducer,
    rolesAndPermissions: rolesAndPermissionsReducer,
    integration: integrationReducer,
    auth: authReducer,
    leads: leadsReducer,
    contacts: contactReducer,
    deals: dealsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
